export const Colors = {
    main : "#50489C" , 
    main2 : "#736dae" , 
    light : "#dad8e9" , 
    lightMain : "#3734CA1A" , 
    hoverMain: "#453c9c" , 
    second :"#455A64" , 
    input : "#C8C8C8" , 
    gray :"#8E8E93" , 
    gray_l : "#A5A5A5" ,
    gray_input : "#DBDBDB" , 
    body :"#F3F5F8" ,  
    olive : "#0E4F68" , 
    lightRed : "#FA433D66" , 
    grayDC : "#DCDCDC" , 
    bgBL: "#F5F7FB" , 
    red : "#C32B43" , 
    hoverRed : "#bb001e" , 
    green : "#27AE60" , 
    hoverGreen : "#00953f" , 
    bg: "#F7F7F7" , 
    hoverGray : "#cdcbcb" , 
    Black60:"#45464E" , 
    Gray1 :"#333333" , 
    Black3: "#8B8D97" , 
    input_fill : "#F5F5F5" , 
    gold : "#F3B51A" , 
    hoverGold : "#f1ac00" ,


}
export const Dimensions = {
    sidebarWidth : "257px" ,
    navbarHeight : "73px" , 
}
